import { Moment } from "jalali-moment";
import * as _moment from "jalali-moment";
import { Component, OnInit, Renderer2, Inject } from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators
} from "@angular/forms";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MAT_DIALOG_DATA
} from "@angular/material";
import {
  MaterialPersianDateAdapter
} from "src/app/shared/material.persian-date.adapter";
import { SoundEnum } from "src/app/enums/sound.enum";
import { TranslateService } from "@ngstack/translate";
import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";
import { ErrorsService } from "src/app/services/common/errors.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { MatDatepicker, MatDialogRef, MatSelect } from "@angular/material";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { CalendarService } from "src/app/services/http/business/calendar/calendar.service";
import { ParrentTermService } from "src/app/services/http/business/parrent-term/parrent-term-service.service";
import { IParentTerm } from "src/app/interfaces/parent-term";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { IError } from "src/app/interfaces/error.interface";

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: "MM/DD"
  },
  display: {
    dateInput: "MM/DD",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MM DD"
  }
};

@Component({
  selector: "app-parent-term-entry",
  templateUrl: "./parent-term-entry.component.html",
  styleUrls: ["./parent-term-entry.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MaterialPersianDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ParentTermEntryComponent implements OnInit {
  param: any;
  errorList: IError[] = [];
  errObject: any;
  form: FormGroup;
  isOwner: boolean;
  holidayList: any;
  editMode: boolean;
  errors = new Array();
  companyList: ICompany;
  companySelected: string;
  date = new FormControl(moment());
  constructor(
    private fb: FormBuilder,
    private renderer: Renderer2,
    private cideService: CIDService,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private calendarService: CalendarService,
    private parrentTermService: ParrentTermService,
    private DialogRef: MatDialogRef<ParentTermEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IParentTerm
  ) {}

  ngOnInit() {
    this.createForm();
    this.checkOwner();
    this.getCompanyList();
    this.getHolidayTypeList();
    this.companySelected = this.cideService.getCID();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
  }

  createForm() {
    this.form = this.fb.group({
      Id: [this.data && this.data.Id ? this.data.Id : 0],
      Company: [
        this.cideService.getCID(),
        Validators.compose([Validators.required])
      ],
      Title: [
        this.data && this.data.Title ? this.data.Title : null,
        Validators.compose([Validators.required])
      ],
      HolidayTypeId: [
        this.data && this.data.HolidayTypeId
          ? this.data.HolidayTypeId.toString()
          : null,
        Validators.compose([Validators.required])
      ],
      MonthAndDayStart: [
        this.data && this.data.MonthAndDayStart
          ? this.setMonthAndDayStart()
          : null,
        Validators.compose([Validators.required])
      ],
      MonthAndDayEnd: [
        this.data && this.data.MonthAndDayEnd ? this.setMonthAndDayEnd() : null,
        Validators.compose([Validators.required])
      ],
      PastTerm: [this.data && this.data.PastTerm ? this.data.PastTerm : null]
    });
  }

  setMonthAndDayStart() {
    let sDate = this.data.MonthAndDayStart.replace("/", "-");
    let dateNow = new Date().getFullYear();
    let year = moment(dateNow, "YYYY").format("jYYYY");
    sDate = year + "-" + sDate;
    return _moment.from(sDate, "fa");
  }

  setMonthAndDayEnd() {
    let eDate = this.data.MonthAndDayEnd.replace("/", "-");
    let dateNow = new Date().getFullYear();
    let year = moment(dateNow, "YYYY").format("jYYYY");
    eDate = year + "-" + eDate;
    return _moment.from(eDate, "fa");
  }

  updateDayStyles() {
    let elements = document.querySelectorAll(".endDate");
    let x = Array.from(elements[0].querySelectorAll(".mat-calendar-header"));
    x.forEach(y => {
      y.classList.add("newClass");
    });
    let z = Array.from(
      elements[0].querySelectorAll(".mat-calendar-body-label")
    );
    z.forEach(y => {
      y.classList.add("newClass");
    });
    let l = Array.from(elements[0].querySelectorAll(".mat-calendar-table"));
    l.forEach(s => {
      s.classList.add("test");
    });
  }
  streamOpened(_event) {
    setTimeout(() => {
      let buttons = Array.from(document.querySelectorAll("input[type=text]"));

      buttons.forEach(btn =>
        this.renderer.listen(btn, "click", () => {
          setTimeout(() => {
            this.updateDayStyles();
          });
        })
      );
      this.updateDayStyles();
    });
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(
    normalizedMonth: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
  }

  getHolidayTypeList() {
    this.calendarService.calendarHolidayList().subscribe(res => {
      this.holidayList = res.DataList;
    });
  }

  getCompanyList() {
    this.companyService.list(0,0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  closeModal() {
    this.DialogRef.close();
  }

  //setCid and load holidayTypeList
  setCid(e: MatSelect) {
    this.cideService.setCID(e.value);
    this.getHolidayTypeList();
  }

  submit(data: IParentTerm) {
    if (!this.data) {
      var sDate: any = document.getElementsByClassName("sDate");
      var eDate: any = document.getElementsByClassName("eDate");
      data.MonthAndDayStart = sDate[0].value;
      data.MonthAndDayEnd = eDate[0].value;
      delete data.Company;
      this.parrentTermService.add(data).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.closeModal();
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    } else {
      var sDate: any = document.getElementsByClassName("sDate");
      var eDate: any = document.getElementsByClassName("eDate");
      data.MonthAndDayStart = sDate[0].value;
      data.MonthAndDayEnd = eDate[0].value;
      this.parrentTermService.edit(data).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.closeModal();
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    }
  }
}
